import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Paper } from '@mui/material';

import NoActiveOrganisatieMessage from '../../components/controls/NoActiveOrganisatieMessage';

import { GeoPackageType } from '../../models/types/geoPackageType';
import ImportGeoPackage from '../../components/controls/ImportGeoPackage';
import { MijnOrganisatieListItem } from '../../models/user/mijnOrganisatieListItem';

import { userManagementService } from '../../services/user-management.service';


const PageKaartenImport: React.FC = () => {
  const [mijnOrganisatie, setMijnOrganisatie] = useState<MijnOrganisatieListItem | null>(null);

  useEffect(() => {
    const storedOrganisatie = userManagementService.getStoredOrganisatie();
    if (storedOrganisatie) {
      setMijnOrganisatie(storedOrganisatie);
    }
  }, []); // Empty dependency array ensures this runs once when the component mounts

  return (
    <>
      <header className="page-header container">
        <h1>Kaarten importeren</h1>
        <p className="header-sub-title">
          Het is mogelijk om kaartlagen uit uw eigen GIS systeem te exporteren in GeoPackage formaat (.gpkg) en te importeren in infraplannen.nl. 
          Het bestand met de kaartlagen moet voldoen aan de <a href="https://wiki.service.mijnaansluiting.nl/wiki/x/AoAUSg" target="_blank" rel="noopener noreferrer">vereisten</a>.
        </p>
      </header>

      <section>
        <div className="page-content container">
          <div className="row">
            <div className="col-12">
              <p>
                Als u een bestand uploadt, dan wordt het bestand weer gecontroleerd. 
                Daarna ziet u een resultaat van de controle in een overzicht van nieuwe, gewijzigde en verwijderde kaartlagen en kunt u besluiten het gecontroleerde Geopackage bestand te laten verwerken.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <div className="content">
        {mijnOrganisatie && mijnOrganisatie.id ? (
          <>
            <ImportGeoPackage type={GeoPackageType.ASSET} organisatieId={mijnOrganisatie.id} />
          </>
        ) : (
          <Paper>
            <NoActiveOrganisatieMessage />
          </Paper>
        )}

      </div>
      
      <Outlet /> 
    </>
  );
};

export default PageKaartenImport;